function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon/notification/bold",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.681334,11.6900702 C18.681334,13.7488006 19.5991671,16.0309802 20.7387258,17.7188802 C20.9004588,18.0423463 20.9141484,18.4256559 20.7157437,18.723263 C20.5204209,19.0162472 20.1834548,19.2049482 19.8374691,19.2049482 L15.6308141,19.2049482 C15.3988776,20.7952705 14.0646421,22 12.4369341,22 C10.8092261,22 9.47499061,20.7952705 9.24305419,19.2049482 L5.03639918,19.2049482 C4.66732375,19.2049482 4.35956345,19.0254213 4.15812455,18.723263 C3.94857119,18.408933 3.94857119,17.993608 4.15055279,17.6911189 C5.30248036,15.8116581 6.12901035,13.7187932 6.12901035,11.6900702 C6.12901035,7.94622991 7.07440045,5.77520335 9.85326355,4.95135738 C10.0869577,3.82775013 11.148488,3 12.4051722,3 C13.6618354,3 14.7233513,3.82772256 14.9570691,4.95130124 C17.7408883,5.77536076 18.681334,7.92872641 18.681334,11.6900702 Z",
  id: "Shape",
  fill: "#422352",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5009567,20 C13.2006944,20 13.8179457,19.5686502 14,19 L11,19 C11.178294,19.5768084 11.7907298,20 12.5009567,20 Z",
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3843239,4.06006218 C12.0882343,4.06006218 11.8138566,4.35000241 11.6,4.82294084 C11.8414167,4.76954324 12.1002968,4.74500907 12.3843239,4.74500907 C12.6586286,4.74500907 12.9051696,4.78075312 13.18557,4.86103482 C12.9693603,4.36561883 12.6882827,4.06006218 12.3843239,4.06006218 Z",
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}));

var SvgNotificationHover = function SvgNotificationHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotificationHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification-hover.6be06beb.svg";
export { ForwardRef as ReactComponent };